import { Button, TextField } from "@mui/material"
import { useEffect, useRef, useState } from "react"

const TextCustom = ({initialText, onChangeText, label}) => {

    const input = useRef()
    const [editingText, setEditingText] = useState(false)
    const [text, setText] = useState(initialText)

    useEffect(() => {
        setText(initialText)
    }, [initialText])

    const enterEditInput = () => {
        setEditingText(true)
    }

    const leaveEditInput = () => {
        setEditingText(false)
        onChangeText(text)
    }

    useEffect(() => {
        if(editingText){
            input.current.focus()
            input.current.setSelectionRange(0, text.length)
        }
    }, [editingText])

    return (
        <>
        <TextField fullWidth multiline sx={{background : 'white', marginTop : 2}}  label={label} inputRef={input} disabled={!editingText} value={text} onInput={(e) => setText(e.target.value || ' ')}/>
            {editingText ? 
                <Button variant="contained" size="small" onClick={leaveEditInput}>Confirmer le {label}</Button> : 
                <Button variant="contained" size="small" onClick={enterEditInput}>Changer le {label}</Button>
            }
        </>
    )


}

export default TextCustom